import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { paymentsAPI } from '@/lib/api';

export default function BookingConfirmPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  const bookingId = searchParams.get('booking_id');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!bookingId || !sessionId) {
      setStatus('error');
      setMessage('Parametri mancanti nella URL');
      return;
    }

    const confirmPayment = async () => {
      try {
        const res = await paymentsAPI.confirmPayment(bookingId, {
          session_id: sessionId,
        });

        if (res.data.status === 'paid') {
          setStatus('success');
          setMessage('Il pagamento è stato confermato con successo!');
        } else {
          setStatus('error');
          setMessage(res.data.message || 'Il pagamento non è ancora stato completato');
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Errore nella conferma del pagamento');
      }
    };

    confirmPayment();
  }, [bookingId, sessionId]);

  return (
    <div className="container mx-auto max-w-lg py-12 px-4">
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-xl">
            {status === 'loading' && 'Conferma pagamento...'}
            {status === 'success' && 'Pagamento confermato!'}
            {status === 'error' && 'Errore pagamento'}
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-6 py-8">
          {status === 'loading' && (
            <>
              <Loader2 className="h-16 w-16 animate-spin text-primary" />
              <p className="text-muted-foreground">Stiamo verificando il pagamento con Stripe...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle2 className="h-16 w-16 text-green-500" />
              <p className="text-center text-muted-foreground">{message}</p>
              <p className="text-sm text-muted-foreground">
                La tua prenotazione è stata confermata. Riceverai una email di conferma.
              </p>
              <Button onClick={() => navigate('/dashboard')} className="mt-4">
                Torna alla Dashboard
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500" />
              <p className="text-center text-muted-foreground">{message}</p>
              <div className="flex gap-3 mt-4">
                <Button variant="outline" onClick={() => navigate(-1)}>
                  Indietro
                </Button>
                <Button onClick={() => navigate('/dashboard')}>
                  Dashboard
                </Button>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
